export enum RunType {
  Immediately = 1,
  Delayed = 2,
  Recurrently = 3
}
